/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";

export default graphql`
    query RootQuery {
        music_viewer {
            account {
                on_waitlist
            }
        }
    }
`;